import { Checkbox, TextField, Text, MessageBarType, Label, FontSizes, Separator } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { MessageComponent } from '../../../../commons/component/MessageComponent';
import { ContractConceptPaymentSchedule } from '../../../../models/Entities/Contracts/ContractConceptPaymentSchedule';
import { ContractStage } from '../../../../models/Entities/Contracts/ContractStage';
import { Checkbox as FluentCheckbox } from '@fluentui/react-components';

// styles
//import '../ProtocolContractFormComponent.css';
import './ContractStageMultiSelector.Style.css';

//i18Next
import { useTranslation, Trans } from 'react-i18next';

// components
import ContractStageMultiselectorItemComponent from './ContractStageMultiselectorItem/ContractStageMultiselectorItem.Component';

// Components functions
import * as ComponentFunctions from './ContractStageMultiselector.Functions';
import { connect } from 'react-redux';

interface StageSaved {
  StageId: number;
  Saved: boolean;
}

const ContractStageMultiSelectorComponent = (props: ComponentFunctions.Props) => {
  
  const [overheadValue, setOverheadValue] = useState<number>(0);
  const [conceptPaymentSchedule, setConceptPaymentSchedule] = useState<ContractConceptPaymentSchedule[]>([]);
  const [StagesStatus, setStagesStatus] = useState<StageSaved[]>([]);
  const [bulkSelectionVersion, setBulkSelectionVersion] = useState<number>(0);
  const [bulkSelectionValue, setBulkSelectionValue] = useState<boolean | undefined>(undefined);
  const [allStagesSelected, setAllStagesSelected] = useState<boolean>(false);

  const isAllSavedHandler = (StageId: number) => {
    setStagesStatus(prevStagesStatus => prevStagesStatus.map((stage: StageSaved) => {
      if(stage.StageId === StageId){
        return {
          StageId: StageId,
          Saved: true
        } as StageSaved;
      }
      return stage as StageSaved;
    }));
  }

  //useTranslation()
  const [t] = useTranslation();

  useEffect(() => {
    const allSaved = StagesStatus.length > 0 && StagesStatus.every((stage: StageSaved) => stage.Saved);
    props.OnAllSaved(allSaved);
  }, [StagesStatus, props.OnAllSaved]);

  useEffect(() => {
    if(props.Stages?.length > 0){
      const stageIds = props.Stages.map((stage: ContractStage) => stage.id);
      const selectedBySchedule = new Set((props.PaymentSchedules || []).map((schedule: ContractConceptPaymentSchedule) => schedule.contractStageId));

      // In edit mode, selection comes from existing payment schedules.
      const allSelectedFromSchedules = stageIds.length > 0 && stageIds.every((stageId: number) => selectedBySchedule.has(stageId));
      const allSelectedFromStageFlag = props.Stages.every((stage: ContractStage) => stage.isSelected);

      setAllStagesSelected(props.ContractConceptId ? allSelectedFromSchedules : allSelectedFromStageFlag);
      // Keep current Saved flags when stages are refreshed from props.
      setStagesStatus((prevStagesStatus: StageSaved[]) => {
        const previousById = new Map(prevStagesStatus.map((stage: StageSaved) => [stage.StageId, stage.Saved]));
        return props.Stages.map((stage: ContractStage) => ({
          StageId: stage.id,
          Saved: previousById.get(stage.id) ?? false,
        }));
      });
    } else {
      props.GetAllContractStagesByAddendumId(props.ContractId, props.ContractAddendumId);
    }
  }, [props.Stages, props.PaymentSchedules, props.ContractConceptId]);

  const selectAllStages = () => {
    setBulkSelectionValue(true);
    setBulkSelectionVersion(prev => prev + 1);
  }

  const deselectAllStages = () => {
    setBulkSelectionValue(false);
    setBulkSelectionVersion(prev => prev + 1);
  }

  const onChangeSelectAll = (checked?: boolean | 'mixed') => {
    const shouldSelect = checked === true;
    setAllStagesSelected(shouldSelect);
    if (shouldSelect) {
      selectAllStages();
      return;
    }

    deselectAllStages();
  }
  
  return (
    <>
      <div className='StageSelectorActions'>
        <FluentCheckbox
          label='Seleccionar / deseleccionar todas las visitas'
          checked={allStagesSelected}
          onChange={(_, data) => onChangeSelectAll(data.checked)}
        />
      </div>
      <ul className='StagesGrid'>
        {[...(props.Stages ?? [])].sort((a: ContractStage, b: ContractStage) => a.stageOrder - b.stageOrder).map((stage: ContractStage, index: number) => (
          <li className={stage.isSelected ? 'StageSelectorItem Active' : 'StageSelectorItem'} key={index}>
            <ContractStageMultiselectorItemComponent
              StageId={stage.id}
              ContractConceptId={props.ContractConceptId}
              ContractAddendumId={props.ContractAddendumId}
              ContractId={props.ContractId}
              CurrencyCode={props.currency}
              ShowInputValues={props.ShowInputValues}
              ConceptSaved={props.ConceptSaved}
              isSavedItem={isAllSavedHandler}
              bulkSelectionVersion={bulkSelectionVersion}
              bulkSelectionValue={bulkSelectionValue}
              applyToRemoteExecution={props.applyToRemoteExecution}
              applyToInFaceExecution={props.applyToInFaceExecution}
              applyToPhoneExecution={props.applyToPhoneExecution}
              applyToFailvisitExecution={props.applyToFailvisitExecution}
              applyToFollowUpExecution={props.applyToFollowUpExecution}
             />
          </li>
        ))}
      </ul>
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ContractStageMultiSelectorComponent as any);
